import { Outlet } from 'react-router-dom';
import { BasicLayout } from 'components/Layout';
import { useUserClientsLoggedIn } from 'domains/auth/UserClientsWrapper/useUserClients';
import { ProfileSelect } from 'pages/ProfileSelect';

export const ProfileSelectedGate: React.FC = ({ children }) => {
  const { isProfileSelected } = useUserClientsLoggedIn();

  if (!isProfileSelected) {
    return (
      <BasicLayout>
        <ProfileSelect />
      </BasicLayout>
    );
  }

  return <>{children ?? <Outlet />}</>;
};
